import React, { useEffect, useState } from 'react';
import styles from './CategoriesAdmin.module.css';
import { adminCategoryAPI } from '../Handlers/categoryAPI';

const CategoriesAdmin = () => {
  const [cats, setCats] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    is_active: true
  });
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [rowLoading, setRowLoading] = useState(null);


  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      const data = await adminCategoryAPI.list();
      setCats(data || []);
    } catch (err) {
      console.error("Erro ao carregar categorias", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name) return;

    setLoading(true);
    try {
      if (editingId) {
        await adminCategoryAPI.edit(editingId, formData);
      } else {
        await adminCategoryAPI.create(formData);
      }

      cancelEdit();
      load();
    } catch (err) {
      alert(editingId ? "Erro ao editar categoria" : "Erro ao criar categoria");
    } finally {
      setLoading(false);
    }
  };

  const remove = async (id) => {
    const ok = window.confirm("Tem certeza que deseja excluir esta categoria?");
    if (!ok) return;

    setRowLoading(id);
    try {
      await adminCategoryAPI.delete(id);
      load();
    } catch (err) {
      alert("Erro ao excluir categoria");
    } finally {
      setRowLoading(null);
    }
  };


  const startEdit = (cat) => {
    setFormData({
      name: cat.name,
      description: cat.description || '',
      is_active: cat.is_active
    });
    setEditingId(cat.id);

    // scroll suave pro form (UX top)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const cancelEdit = () => {
    setEditingId(null);
    setFormData({ name: '', description: '', is_active: true });
  };




  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>Categorias</h1>
        <p>Gerencie as classificações de produtos da sua loja.</p>
      </header>

      <div className={styles.layout}>
        {/* Formulário de Criação */}
        <aside className={styles.formCard}>
          <h3>{editingId ? 'Editar Categoria' : 'Nova Categoria'}</h3>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.inputGroup}>
              <label>Nome da Categoria</label>
              <input 
                name="name"
                placeholder="Ex: Eletrônicos" 
                value={formData.name} 
                onChange={handleInputChange} 
                required
              />
            </div>

            <div className={styles.inputGroup}>
              <label>Descrição</label>
              <textarea 
                name="description"
                placeholder="Breve descrição da categoria..." 
                value={formData.description} 
                onChange={handleInputChange} 
                rows="4"
              />
            </div>

            <div className={styles.checkboxGroup}>
              <input 
                type="checkbox" 
                id="is_active"
                name="is_active"
                checked={formData.is_active} 
                onChange={handleInputChange} 
              />
              <label htmlFor="is_active">Categoria Ativa</label>
            </div>

            <button type="submit" className={styles.btnPrimary} disabled={loading}>
              {loading
                ? 'Salvando...'
                : editingId
                  ? 'Atualizar Categoria'
                  : 'Criar Categoria'}
            </button>
            {editingId && (
              <button
                type="button"
                className={styles.btnSecondary}
                onClick={cancelEdit}
              >
                Cancelar edição
              </button>
            )}
          </form>
        </aside>

        {/* Lista de Categorias */}
        <main className={styles.listCard}>
          <div className={styles.listHeader}>
            <h3>Categorias Existentes</h3>
            <span className={styles.badgeCount}>{cats.length} total</span>
          </div>

          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Nome</th>
                  <th>Slug</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {cats.length === 0 && (
                  <tr><td colSpan="4" className={styles.empty}>Nenhuma categoria cadastrada.</td></tr>
                )}
                {cats.map(c => (
                  <tr key={c.id}>
                    <td>
                      <span className={`${styles.dot} ${c.is_active ? styles.active : styles.inactive}`}></span>
                    </td>
                    <td>
                      <div className={styles.catInfo}>
                        <strong>{c.name}</strong>
                        <small>{c.description || 'Sem descrição'}</small>
                      </div>
                    </td>
                    <td><code>/{c.slug}</code></td>
                    <td>
                      <button
                        type="button"
                        className={styles.btnAction}
                        onClick={() => startEdit(c)}
                        disabled={rowLoading === c.id}
                      >
                        Editar
                      </button>

                      <button
                        type="button"
                        className={styles.btnDanger}
                        onClick={() => remove(c.id)}
                        disabled={rowLoading === c.id}
                      >
                        {rowLoading === c.id ? 'Excluindo...' : 'Excluir'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CategoriesAdmin;